var React = require('react');

function TwitterCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20","cy":"20","r":"20","fill":"#2AA3EF","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M28.205 14.911a6.751 6.751 0 0 1-1.934.53 3.376 3.376 0 0 0 1.48-1.861c-.65.385-1.37.665-2.138.816a3.367 3.367 0 0 0-5.737 3.07 9.557 9.557 0 0 1-6.938-3.517 3.342 3.342 0 0 0-.456 1.693c0 1.167.595 2.198 1.497 2.8a3.338 3.338 0 0 1-1.524-.42v.043c0 1.63 1.16 2.99 2.7 3.3a3.36 3.36 0 0 1-1.52.057 3.372 3.372 0 0 0 3.145 2.338 6.763 6.763 0 0 1-4.985 1.394 9.527 9.527 0 0 0 5.16 1.512c6.193 0 9.58-5.129 9.58-9.576 0-.147-.004-.291-.01-.436a6.841 6.841 0 0 0 1.68-1.742Z","fill":"#fff","key":1})]);
}

TwitterCircle.defaultProps = {"viewBox":"0 0 40 40","fill":"none"};

module.exports = TwitterCircle;

TwitterCircle.default = TwitterCircle;
